import { createStyles, Theme, WithStyles, withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import React from "react";
import { ReadOnlyField as ReadOnlyFieldHelper } from "./helpers";
import { FieldProps } from "./models";

const styles = (theme: Theme) =>
  createStyles({
    display: {
      color: theme.palette.text.primary,
      marginTop: theme.spacing(2),
      padding: "7px 0 9px",
    },
  });

interface ReadOnlyFieldProps extends FieldProps<any>, WithStyles<typeof styles> {}

export const ReadOnlyFieldComponent = (props: ReadOnlyFieldProps) => {
  const { idSchema, schema, uiSchema, errorSchema, formData, rawErrors, classes } = props;

  const id = idSchema.$id;
  const label = schema.title;
  const help = uiSchema["ui:help"] as string | undefined;
  const errors = errorSchema?.__errors ?? rawErrors;

  let content;
  if (formData) {
    if (schema.type === "string" || schema.type === "number") {
      content = formData;
    } else if (schema.type === "boolean") {
      content = formData ? "Yes" : "No";
    } else if (schema.type === "array") {
      content = ((formData as any[]).reduce((acc, element) => {
        acc.push(element);
        return acc;
      }, []) as string[]).join(", ");
    }
  }

  return (
    <ReadOnlyFieldHelper
      id={id}
      className={classNames(classes.display, props.className)}
      label={label}
      errors={errors}
      help={help}
    >
      {content}
    </ReadOnlyFieldHelper>
  );
};

export const ReadOnlyField = withStyles(styles)(ReadOnlyFieldComponent);
